export const assignRecipients = recipient => ({
  type: 'ASSIGN_RECIPIENT',
  recipient,
})

export const getRecipient = () => dispatch =>
  new Promise(resolve => {
    /* global Office */
    if (Office.context.mailbox.item.internetMessageId) {
      resolve(Office.context.mailbox.item.to[0].emailAddress)
      dispatch(assignRecipients(Office.context.mailbox.item.to[0].emailAddress))
    } else {
      Office.context.mailbox.item.to.getAsync(result => {
        if (!result.value.length) {
          dispatch(assignRecipients(null))
          resolve(null)
          return
        }
        dispatch(assignRecipients(result.value[0].emailAddress))
        resolve(result.value[0].emailAddress)
      })
    }
  })
